<script setup lang="ts">
import { Utill } from '@/stores/Utill'
import { Data } from '@/stores/data'
import { ref, watch } from 'vue'
import { ElementTip } from '@/stores/ElementTip'
var def = defineProps({
  backText: {
    type: Object,
    default: {},
  },
  isNeedClose: {
    type: Boolean,
    default: false
  },
  width: {
    type: Number,
    default: 203
  }
})
const $emit = defineEmits([
  'qxHandler', "upLoadClick"
])
let fileExtension = ref('')
function getWdIco() {
  let wdIco = 'wd'
  if (def.backText?.loadingState == 3) {
    wdIco = 'wd-error'
  } else {
    fileExtension.value = def.backText?.data?.name?.split('.').pop() // 获取文件后缀
    if (!fileExtension.value) {
      wdIco = 'wd'
    } else {
      wdIco = Utill.getIcoFromUrl(fileExtension.value)
    }
  }
  return wdIco
}
function upLoadClick() {
  // $emit('upLoadClick')
  if (def.backText?.data?.pdfUrl) {
    $emit('upLoadClick', def.backText?.data?.pdfUrl);
  } else {
    ElementTip.warningTip("该文件暂时无法预览")
  }
}
function qxHandler() {
  $emit('qxHandler', def.backText.wjId)
  // def.def
}
</script>

<template>
  <div class="documents-ctr" :style="width ? 'width:' + width + 'px;' : ''">
    <div class="wd-ctr" @click="upLoadClick">
      <div class="wd-ico-ctr">
        <img :src="'icons/' + getWdIco() + '.svg'" :class="backText.loadingState == 3 ? 'error-ico' : ''"
          v-if="backText.loadingState != 1" />
        <div v-else v-loading="true" class='loading-el'>

          <!-- <van-loading type="spinner" size="20px" /> -->
        </div>
      </div>
      <div class="wd-bt-ctr">
        <div class="wb-name" v-if="backText.loadingState != 1">
          {{ backText.data?.name ? backText.data.name : '上传文件' }}
        </div>
        <div class="wb-name" v-else>正在解析中</div>

        <div class="wb-size font-ten" v-if="backText.loadingState == 2">
          {{ fileExtension + '，' }}{{ backText.data.size }}
        </div>
        <div class="wb-size font-ten error-tip" v-else-if="backText.loadingState == 3">
          {{ backText.errorTip }}
        </div>
        <div class="wb-size font-ten" v-else>上传中</div>
      </div>
    </div>
    <div class="wd-qx-ctr" @click="qxHandler" v-if="isNeedClose">
      <img src="@/assets/close.svg" />
    </div>
  </div>
</template>

<style scoped>
.documents-ctr {
  position: relative;
  width: 203px;
}

.loading-el {
  width: 20px;
  height: 20px
}

.wd-ctr {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
  background-color: #fff;
  border-radius: 12px;
  padding: 8px 16px 8px 8px;
  border: 0.5px solid #c9cdd4;
}

.wb-size.error-tip {
  color: #ff3b30;
}

.wb-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  font-size: 12px;
}

.wb-size {
  color: #86909c;
}

.wd-bt-ctr {
  flex: 1;
  overflow: hidden;
}

.wd-qx-ctr {
  width: 16px;
  position: absolute;
  top: 4px;
  right: 2px;
  /* background: #e5e6eb;
  border-radius: 50%; */
  padding: 4px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wd-ico-ctr {
  width: 36px;
  height: 36px;
  background: #f7f8fa;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wd-ico-ctr img {
  width: 26px
}

.wd-ico-ctr .error-ico {
  width: 20px;
}
</style>
